<div class="cp5" fxLayout="row wrap" style="justify-content: space-between">
    <span class="mt-3 px-2" style="color: red">&nbsp;&nbsp;{{"mandataire_cond" | translate}}</span>
<div  fxLayoutAlign="end end">
    
    <button (click)="add()" color="primary" mat-button type="button">
        <mat-icon>add_circle_outline</mat-icon>
    </button>
</div>
</div>
<div>

    <div fxFlex="100" fxFlex.lt-md="100">
        <mat-card appCard class="table-card">
            <mat-card-content>

                <table [dataSource]="dataSource" mat-table style="width: 100%">

                    <ng-container
                            *ngFor="let column of displayedColumns"
                            [matColumnDef]="column"
                    >
                        <th *matHeaderCellDef mat-header-cell>
                            {{ labels[column] | translate }}
                        </th>

                        <td *matCellDef="let type" mat-cell>
                            {{ type[column] | typedValue | async | translate }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="N">
                        <th *matHeaderCellDef mat-header-cell>
                            {{ "Numero" | translate }}
                        </th>
                        <td (click)="open(element)" *matCellDef="let element; let i = index;  " mat-cell
                            style="cursor: pointer">
                            {{i + 1}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th *matHeaderCellDef mat-header-cell></th>
                        <td *matCellDef="let element; let i = index" mat-cell width="20%">
                            <button (click)="edit(element,i)" color="primary" mat-button style="color: #3498db"
                                    type="button">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button
                                    (click)="removeCart(i,element)"
                                    color="primary"
                                    mat-button
                                    type="button"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr *matHeaderRowDef="displayedColumnss" mat-header-row></tr>
                    <tr *matRowDef="let row; columns: displayedColumnss" mat-row></tr>

                </table>
                <app-empty-list-container [list]="Ussine" [withoutBorder]="true"></app-empty-list-container>
            </mat-card-content>


        </mat-card>
        <div class="cp5" fxLayoutAlign="end end" mat-dialog-actions>
            <app-spinner-container>
                <button (click)="addf()" color="primary" mat-raised-button>
                    <span translate>submit</span>
                </button>
            </app-spinner-container>
        </div>
    </div>

</div>

